// Config for Cookie Consent feature
// Toggle via env vars when needed
const consentConfig = {
  // Explicit opt-in via env; defaults to disabled until enabled for QA
  enabled: process.env.REACT_APP_CONSENT_ENABLED === 'true',
  serverPersistenceEnabled: process.env.REACT_APP_CONSENT_SERVER_PERSIST === 'true',
  consentVersion: '1.0.0',
  cookieName: 'cookie_consent',
  cookieExpireDays: 180, // ~6 months
  cookieAttributes: {
    path: '/',
    sameSite: 'Lax',
    secure: true
  },
  // Categories recognized by the UI and manager
  categories: ['necessary', 'functional', 'analytics', 'advertising'],
  // Optional vendor to category mapping
  vendorCategoryMap: {
    GA4: 'analytics',
    Segment: 'analytics',
    MetaPixel: 'advertising'
  },
  // UI text (externalized for i18n later)
  copy: {
    banner: {
      message:
        'We use cookies to enhance your experience, analyze usage, and deliver personalized content. Strictly necessary cookies are always on. See our Privacy and Cookie Policy for details.',
      buttons: {
        acceptAll: 'Accept all',
        reject: 'Reject non-essential',
        customize: 'Customize'
      }
    },
    modal: {
      title: 'Cookie preferences',
      description:
        'Manage your cookie preferences by category. Necessary cookies are required for the site to function and cannot be disabled.',
      categories: {
        necessary: {
          label: 'Necessary',
          description: 'Required for core site functionality.'
        },
        functional: {
          label: 'Functional',
          description: 'Enhance features like remembering preferences.'
        },
        analytics: {
          label: 'Analytics/Performance',
          description: 'Help us understand site usage to improve performance.'
        },
        advertising: {
          label: 'Advertising/Targeting',
          description: 'Used to deliver relevant advertising and measure effectiveness.'
        }
      },
      buttons: {
        cancel: 'Cancel',
        save: 'Save preferences',
        close: 'Close preferences'
      }
    }
  },
  // UI preferences
  ui: {
    position: 'bottom', // or 'top'
    theme: 'light' // future use for theming
  },
  // Region targeting; future use. For now, show globally
  regions: {
    mode: 'global',
    list: []
  }
};

export default consentConfig;
